module.exports = __webpack_public_path__ + "static/forte_main_3-a987634067671ce890ee83d16fa65800.png";